import { last } from "common-utils/utils/array";
import {
  getInfiniteResourceKey$GetSecondaryListings,
  httpGet$GetSecondaryListings,
} from "kreate-server/commands/GetSecondaryListings/fetcher";
import { GetSecondaryListings$Params } from "kreate-server/commands/GetSecondaryListings/typing";

import { useOffsetPagination } from "./useOffsetPagination";

export function useSecondaryListingsInfinite(
  initialParams: GetSecondaryListings$Params | null | undefined
) {
  const api = useOffsetPagination({
    initialParams,
    getKey: (params) => getInfiniteResourceKey$GetSecondaryListings(params),
    fetcher: async (params) =>
      await httpGet$GetSecondaryListings("/api/v1/secondary/listings", params),
    getLength: (result) => result.listings.length,
  });

  return {
    pages: api.swr.data?.map((d) => d.result),
    items: api.swr.data?.flatMap((d) => d.result.listings),
    error: api.swr.error,
    statusIndicator: api.statusIndicator,
    loadMore: api.loadMore,
    totalCount: last(api.swr.data)?.result.count,
    initialParams,
  };
}
